import { createReducer } from '@reduxjs/toolkit';
import * as types from './type';

const initialState = {
  status: false,
};

const reducer = createReducer(initialState, {
  [types.ALLOW_COOKIES_STATUS]: (state, action) => ({
    ...state,
    status: action.payload,
  }),
});

export default reducer;
